<template>
  <v-container fluid>
    <v-data-table
      :items-per-page="itemsPerPage"
      must-sort
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :headers="headers"
      :items="itemShow"
      :item-class="rowStyle"
      :show-select="showSelect"
      v-model="dataSelectedItems"
      :custom-sort="customSort"
      :multi-sort="false"
    >
      <template v-slot:item.preview="{item}">
        <v-card
          max-height="150"
          max-width="100"
          @click="openDialog('videoDialog', { src: item.uri, id: item.id })"
        >
          <v-img v-if="!!item.preview_url && item.status==='done'"
                 :src="item.preview_url"
                 height="150"
                 contain
          />
        </v-card>
      </template>

      <template v-slot:item.type="{item}">
        {{ typeName(item.type) }}
      </template>

      <template v-slot:item.source="{item}">
        <span
          class="font-weight-bold with-pointer"
          @click="openDialog(
            'selectedVideo',
            {
                  id: item.id,
                  sourceId: item.source_id,
                  ambassadorId: item.ambassador_id
                }
            )"
        >{{
            item.videosource
              ? item.videosource.name
              : 'empty'
          }}</span>

        <div
          class="with-pointer"
          v-if="hasSomeAbilities($constants.ABILITY.AMBASSADORS) &&
            item.videosource && item.videosource.id === $constants.VIDEO_SOURCES.AMBASSADOR"
          @click="openDialog(
            'selectedVideo',
            {
                  id: item.id,
                  sourceId: item.source_id,
                  ambassadorId: item.ambassador_id
                }
            )">
          <NameFirstNameLastIdOrEmpty
            :subject="item.ambassador"
            tooltip="click to set ambassador"
          />
        </div>

        <NameFirstNameLastIdOrEmpty
          v-if="!hasSomeAbilities($constants.ABILITY.AMBASSADORS) &&
          item.videosource && item.videosource.id === $constants.VIDEO_SOURCES.AMBASSADOR"
          :subject="item.ambassador"
        />
      </template>

      <template v-slot:item.order="{item}">
        <v-edit-dialog
          @save="requestVideoDataPoiInfo(item)"
          @open="dialogs.selectedVideo.data = {
                  id: item.id,
                  priorityId: item.poi_relation.priority
                }"
          large
        >
            <span class="font-weight-bold">{{
                priorityObjectName(item.poi_relation.priority)
              }}</span>
          <template v-slot:input>
            <div
              class="ma-2"
            >
              <DataList
                :item-model.sync="dialogs.selectedVideo.data.priorityId"
                :type-object="$constants.DATA_LISTS.VIDEO_PRIORITIES_LIST"
                label="display order"
              />
            </div>
          </template>
        </v-edit-dialog>
      </template>

      <template v-slot:item.errors="{item}">
        <v-alert
          v-if="item.broken_message"
          class="my-0 pa-1"
          outlined
          color="error"
        >
          <div
            v-for="(message, id) in item.broken_message"
            :key="id"
          >
            - {{ message }}
          </div>
        </v-alert>
        <v-alert
          v-if="item.status==='fail'"
          outlined
          type="error"
        >
          Saving to database is failed
        </v-alert>
        <v-alert
          v-if="item.status==='in_progress'"
          outlined
          type="warning"
        >
          Uploading in progress
        </v-alert>
        <v-alert
          v-if="!item.preview_url && item.status==='done'"
          outlined
          type="info"
        >
          Has no preview
        </v-alert>
        <v-container
          v-if="item.error && item.error[0]['id'] !== 0"
          class="ma-0 pa-0"
        >
          <v-alert
            v-for="error in item.error"
            :key="error.id"
            outlined
            color="error"
          >
            {{ error.name }}
          </v-alert>
        </v-container>
      </template>

      <template v-slot:item.actions="{item}">
        <v-btn
          icon
          color="red"
          @click="openDialog(
            'moveVideoDialog',
            { id: item.id, newPoi: null, priority: item.poi_relation.priority})
          "
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
              >
                mdi-arrow-right-bold
              </v-icon>
            </template>
            Move video
          </v-tooltip>
        </v-btn>

        <v-btn
          icon
          @click="updateVideoInfo(item.id)" >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-update
                </v-icon>
            </template>
            update info
          </v-tooltip>
        </v-btn>

        <v-btn
          v-if="isIncludeToggleHideButton"
          depressed
          small
          @click="toggleHideVideo(item.id)"
        >
          <v-tooltip
            v-if="item.is_hidden"
            bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
              >
                mdi-eye
              </v-icon>
            </template>
            reveal
          </v-tooltip>

          <v-tooltip
            v-else
            bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
              >
                mdi-eye-off
              </v-icon>
            </template>
            hide
          </v-tooltip>
        </v-btn>

        <v-btn
          v-if="!item.is_archive"
          icon
          @click="toggleArchiveVideo(item.id)">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">
                mdi-archive-arrow-down
              </v-icon>
            </template>
            To Archive
          </v-tooltip>
        </v-btn>
        <v-btn
          v-if="item.is_archive"
          icon
          @click="toggleArchiveVideo(item.id)">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">
                mdi-archive-arrow-up
              </v-icon>
            </template>
            From Archive
          </v-tooltip>
        </v-btn>

        <v-btn
          icon
          @click="deleteVideo(item.id)" >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <slot>
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="red"
                >
                  mdi-delete
                </v-icon>
              </slot>
            </template>
            delete video
          </v-tooltip>
        </v-btn>
      </template>
    </v-data-table>

    <DialogVideoPlayer
      :show.sync="dialogs.videoDialog.isOpened"
      :src.sync="dialogs.videoDialog.data.src"
      :video-id="dialogs.videoDialog.data.id"
    />

    <confirm-dialog
      :is-open.sync="dialogs.moveVideoDialog.isOpened"
      dialog-max-width="400"
      :is-disable-confirm-button="!dialogs.moveVideoDialog.data.newPoi"
      @confirm="moveVideo"
      confirm-button-text="Move"
    >
      <template v-slot:title>
        Move video {{ dialogs.moveVideoDialog.data.id }}
      </template>
      <template v-slot:body>
        <v-row>
          <v-col>
            <v-text-field
              label="Old poi id"
              :value="poiId"
              disabled
            />
          </v-col>
          <v-col>
            <v-text-field
              label="New poi id"
              v-model="dialogs.moveVideoDialog.data.newPoi"
            />
          </v-col>
          <v-col>
            <DataList
              :item-model.sync="dialogs.moveVideoDialog.data.priority"
              :type-object="$constants.DATA_LISTS.VIDEO_PRIORITIES_LIST"
              label="display order"
            />
          </v-col>
        </v-row>
      </template>
    </confirm-dialog>

    <confirm-dialog
      :is-open.sync="dialogs.selectedVideo.isOpened"
      dialog-max-width="400"
      @confirm="updateVideoDataFields"
      confirm-button-text="save"
    >
      <template v-slot:title>
        Set source
      </template>
      <template v-slot:body>
        <v-row>
          <DataList
            :item-model.sync="dialogs.selectedVideo.data.sourceId"
            :type-object="$constants.DATA_LISTS.VIDEO_SOURCES_LIST"
            label="source"
            :is-update-on-start="true"
          />
        </v-row>
        <v-row
          v-if="dialogs.selectedVideo.data.sourceId === $constants.VIDEO_SOURCES.AMBASSADOR"
        >
          <AmbassadorList
            :ambassador-model.sync="dialogs.selectedVideo.data.ambassadorId"
            :is-update-on-start="true"
          />
        </v-row>
      </template>
    </confirm-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import manageDialogsMixin from '../mixins/manageDialogsMixin';
import DialogVideoPlayer from './dialogs/DialogVideoPlayer.vue';
import NameFirstNameLastIdOrEmpty from './microcomponents/NameFirstNameLastIdOrEmpty.vue';
import AmbassadorList from './DataLists/AmbassadorList.vue';
import ConfirmDialog from './dialogs/ConfirmDialog.vue';
import DataList from './DataLists/DataList.vue';
import fetchErrorMixin from '../mixins/fetchErrorMixin';

export default {
  name: 'MediaVideoTable',
  components: {
    DataList,
    ConfirmDialog,
    NameFirstNameLastIdOrEmpty,
    DialogVideoPlayer,
    AmbassadorList,
  },

  mixins: [
    manageDialogsMixin,
    fetchErrorMixin,
  ],

  props: {
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    showSelect: {
      type: Boolean,
      default: true,
    },
    items: [],
    selectedItems: {
      type: Array,
      default: () => [],
    },
    hiddenButtons: {
      type: Array,
      default: () => ([]),
    },
    poiId: Number,
    showArchive: Boolean,
  },

  data() {
    return {
      sortBy: 'order',
      sortDesc: false,
      id: null,
      dataSelectedItems: [],
      headers: [
        { text: 'ID', value: 'id', width: '20' },
        { text: 'Preview', value: 'preview', sortable: false },
        { text: 'Type', value: 'type' },
        { text: 'Source', value: 'source' },
        { text: 'Order', value: 'order' },
        { text: 'Errors', value: 'errors', sortable: false },
        {
          text: '',
          value: 'actions',
          sortable: false,
          width: '50px',
        },
      ],
      dialogs: {
        videoDialog: {
          isOpened: false,
          data: {
            src: '',
            id: null,
          },
          defaults: {
            src: '',
            id: null,
          },
        },
        selectedVideo: {
          isOpened: false,
          data: {
            id: null,
            sourceId: null,
            priorityId: null,
            ambassadorId: null,
          },
          defaults: {
            id: null,
            sourceId: null,
            priorityId: null,
            ambassadorId: null,
          },
        },
        moveVideoDialog: {
          isOpened: false,
          data: {
            id: null,
            newPoi: null,
            priority: null,
          },
          defaults: {
            id: null,
            newPoi: null,
            priority: null,
          },
        },
      },
      priorities: {},
    };
  },

  created() {
    this.priorities = this.listItem(this.$constants.DATA_LISTS.VIDEO_PRIORITIES_LIST.type);
    this.updateList({ ...this.$constants.DATA_LISTS.VIDEO_PRIORITIES_LIST, withOverlay: true });
  },

  methods: {
    ...mapActions({
      updateList: 'datalists/updateList',
      setSnack: 'snackbar/setState',
    }),

    toggleHideVideo(videoId) {
      this.$requestHelpers
        .get(`api/admin/videodata/toggleHideBrokenVideo/${videoId}`)
        .then((response) => {
          this.$emit('toggleHideVideo', { videoId, response });
        });
    },

    toggleArchiveVideo(videoId) {
      this.$requestHelpers
        .get(`api/admin/videodata/toggleArchive/${videoId}`)
        .then((response) => {
          const index = this.items.findIndex((e) => e.id === videoId);
          Object.assign(this.items[index], response.data.result);

          this.$emit('toggleArchiveVideo', { videoId, response });
        });
    },

    deleteVideo(videoId) {
      this.$confirm('Are you sure you want to delete this video?').then((res) => {
        if (!res) return;

        this.$requestHelpers
          .delete(`api/admin/videodata/${videoId}`)
          .then(() => {
            const items = this.items.filter((video) => video.id !== videoId);
            this.$emit('update:items', items);
          }).catch((error) => {
            this.$emit('error', this.fetchError(error));
          });
      });
    },

    updateVideoInfo(videoId) {
      this.$emit('init');

      this.$requestHelpers
        .get(`api/admin/videodata/updateInfo/${videoId}`)
        .then((response) => {
          const items = this.items.map(
            (video) => (video.id !== videoId
              ? video
              : Object.assign(video, response.data)),
          );
          this.$emit('update:items', items);
        });
    },

    moveVideo() {
      this.$requestHelpers
        .post(`api/admin/videodata/move/${this.dialogs.moveVideoDialog.data.id}`, {
          newPoi: this.dialogs.moveVideoDialog.data.newPoi,
          priority: this.dialogs.moveVideoDialog.data.priority,
        })
        .then((response) => {
          if (response.data.success) {
            const items = this.items
              .filter((video) => video.id !== this.dialogs.moveVideoDialog.data.id);
            this.$emit('update:items', items);
          }

          this.closeDialog('moveVideoDialog');
        });
    },

    updateVideoDataFields() {
      this.$requestHelpers
        .patch(
          `api/admin/videodata/${this.dialogs.selectedVideo.data.id}`,
          {
            source_id: this.dialogs.selectedVideo.data.sourceId,
            ambassador_id: this.dialogs.selectedVideo.data.ambassadorId,
          },
        )
        .then((response) => {
          this.updateData(response.data);
        }).finally(() => {
          this.closeDialog('selectedVideo');
        });
    },

    requestVideoDataPoiInfo(video) {
      if (video.priority === 0 && this.dialogs.selectedVideo.data.priorityId !== 0) {
        this.getPreviewPriorityAmount(video);
      } else {
        this.savePoiVideoPriority(video);
      }
    },

    getPreviewPriorityAmount(video) {
      this.previewPriorityDialog.previewsAmount = null;

      this.$requestHelpers
        .get(
          `api/admin/poi/prioritypreviewamount/${this.poiId}`,
        )
        .then((response) => {
          this.$confirm(`This POI has ${response.data.result.count} previews left. <br/> `
            + 'Are you sure you want change it\'s display order?').then((res) => {
            if (!res) {
              return;
            }
            this.savePoiVideoPriority(video);
          });
        });
    },

    savePoiVideoPriority(video) {
      this.$requestHelpers
        .patch(
          `api/admin/video/updateVideoPriority/${video.id}`,
          {
            priority: this.dialogs.selectedVideo.data.priorityId,
          },
        )
        .then((response) => {
          const videoIndex = this.items.findIndex(
            (el) => el.id === video.id,
          );

          this.$set(
            this.items,
            videoIndex,
            {
              ...this.items[videoIndex],
              poi_relation: response.data,
            },
          );
        }).finally(() => {
          this.dialogs.selectedVideo.data.id = null;
          this.dialogs.selectedVideo.data.priorityId = null;
        });
    },

    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        let aSource;
        let bSource;

        switch (index[0]) {
          case 'type':
            return isDesc[0]
              ? this.typeName(b[index[0]]).localeCompare(this.typeName(a[index[0]]))
              : this.typeName(a[index[0]]).localeCompare(this.typeName(b[index[0]]));
          case 'source':
            aSource = a.videosource && a.videosource.id
              ? a.videosource.id
              : 0;
            bSource = b.videosource && b.videosource.id
              ? b.videosource.id
              : 0;
            return isDesc[0]
              ? bSource - aSource
              : aSource - bSource;
          case 'order':
            return isDesc[0]
              ? b.poi_relation.priority - a.poi_relation.priority
              : a.poi_relation.priority - b.poi_relation.priority;
          default:
            return isDesc[0]
              ? b[index[0]] - a[index[0]]
              : a[index[0]] - b[index[0]];
        }
      });

      return items;
    },

    clearSelectedItems() {
      this.dataSelectedItems = [];
    },

    updateBulk(itemIds, itemFields) {
      return this.$requestHelpers
        .post('api/admin/videodata/updateBulk', { ids: itemIds, itemFields })
        .then((response) => {
          if (response.data.success) {
            let commonStatus = true;
            for (let i = 0; i < response.data.result.statuses.length; i += 1) {
              const { status } = response.data.result.statuses[i];

              commonStatus &&= status;

              if (status) {
                this.updateData(response.data.result.items[i]);
              }
            }

            if (commonStatus) {
              this.setSnack({
                color: 'green',
                text: response.data.message ? response.data.message : 'saved',
              });
            } else {
              this.setSnack({
                color: 'orange',
                text: response.data.message,
              });
            }
          }
        }).finally(() => {
          this.clearSelectedItems();
        });
    },

    updateData(data) {
      const index = this.items.findIndex((e) => e.id === data.id);

      this.$set(this.items, index, data);

      this.$emit('update:items', this.items);
    },
  },

  computed: {
    ...mapGetters({
      listItem: 'datalists/listItem',
    }),

    itemShow() {
      if (this.items) {
        return this.items.filter((el) => el.is_archive === (this.showArchive ? 1 : 0));
      }

      return [];
    },

    rowStyle() {
      return () => 'custom-row-height';
    },

    isIncludeToggleHideButton() {
      return this.hiddenButtons.includes('toggleHidden');
    },

    priorityObjectName() {
      return (priorityId) => {
        const priority = this.priorities.list.find((item) => item.id === priorityId);
        return priority === undefined ? 'empty' : `${priority.name}`;
      };
    },

    typeName() {
      return (type) => {
        switch (type) {
          case 'slide':
            return 'Slideshow';
          case 'reel':
          default:
            return 'Reel';
        }
      };
    },
  },

  watch: {
    dataSelectedItems: {
      handler() {
        this.$emit('update:selectedItems', this.dataSelectedItems);
      },
    },
  },
};

</script>
<style scoped>
.with-pointer {
  cursor: pointer;
}
</style>

<style>
.custom-row-height {
  height: 150px !important;
}
</style>
